<template>
  <div>
    <!-- 视频观看页面 -->
    <div class="container top_fixed">
      <div class="row top_fixed">
        <div ref="topHeight" class="col-md-8 offset-md-2 top_fixed">
          <Search :liveId="live.liveId" :pages="routeLive" />
          <div>
            <!-- 视频区域 -->
            <div
              class="videoContext"
              id="videoBg"
              :style="{ background: live.liveCoverImg }"
              oncontextmenu="return false"
            >
              <!-- 群公告区域 -->
              <div
                class="notice-card-wrapper"
                :class="showNotice ? '' : 'hide-notice'"
              >
                <div class="inner-container">
                  <van-notice-bar
                    left-icon="volume-o"
                    :text="live.remark"
                    background="none"
                    color="yellow"
                  />
                </div>
              </div>
              <div id="vs" style="width: 100%"></div>
            </div>
            <div class="info">
              <div>
                <img src="../../../assets/img/lumi.png" alt />
                <span>{{ live.liveName }}</span>
              </div>
              <div class="current1" v-if="live.liveStatus === 1">
                <span class="title">线路切换：</span>
                <span
                  class="liveLine"
                  :class="activited == 1 ? 'live_activited' : ''"
                  @click="switchLine(1)"
                  >线路一</span
                >
                <span
                  class="liveLine"
                  :class="activited == 2 ? 'live_activited' : ''"
                  @click="switchLine(2)"
                  >线路二</span
                >
              </div>
              <div
                class="current"
                v-if="
                  live.liveDisplayOnlineTag == 1 ||
                  live.liveDisplayWatchTag == 1
                "
              >
                <span class="spanNum" v-if="live.liveStatus === 1">
                  <span v-if="live.liveDisplayWatchTag == 1">
                    观看人次：{{ current.total ? current.total : '-' }}
                  </span>
                  <span
                    v-if="
                      live.liveDisplayOnlineTag == 1 &&
                      live.liveDisplayWatchTag == 1
                    "
                    >/
                  </span>
                  <span v-if="live.liveDisplayOnlineTag == 1">
                    在线人数： {{ current.times ? current.times : '-' }}
                  </span>
                </span>
                <span
                  class="spanNum"
                  v-if="live.liveStatus === 2 && live.liveDisplayWatchTag == 1"
                >
                  <span>观看人次：{{ total ? total : '--' }}</span>
                </span>
              </div>
              <p class="col-red">
                {{ live.liveStartTime }} 至 {{ live.liveEndTime }}
              </p>
            </div>

            <!-- 文本区域 -->
            <!-- 标题 -->
            <mt-navbar v-model="selected" @input="getCurrentSelect">
              <mt-tab-item id="score">向老师提问</mt-tab-item>
              <mt-tab-item id="comment">评论</mt-tab-item>
              <mt-tab-item id="note">{{
                live.liveCrowdGroup ? '联系我们' : '直播详情'
              }}</mt-tab-item>
            </mt-navbar>
          </div>
        </div>
      </div>
    </div>
    <div class="container bottom_fixed">
      <div class="row bottom_fixed">
        <div class="col-md-8 offset-md-2 bottom_fixed">
          <!-- 内容 -->
          <mt-tab-container v-model="selected">
            <!-- 评论区 -->
            <mt-tab-container-item id="comment">
              <div class="questions-list" :style="{ marginTop: topHeight }">
                <div
                  class="questions-list-item"
                  v-for="(item, index) in commentLists"
                  :key="index"
                >
                  <div class="questions-list-item-heading">
                    <img
                      :src="
                        item.avatar
                          ? item.avatar
                          : require('../../../assets/img/timg.jpg')
                      "
                    />
                    <span class="questions-list-item-username"
                      >{{ item.nick }}
                    </span>
                    <span
                      v-if="item.userId == userId"
                      style="
                        background-color: #f0f0f0;
                        width: 30px;
                        display: inline-block;
                        text-align: center;
                      "
                    >
                      <font color="#BEBEBE">我</font>
                    </span>
                  </div>
                  <div class="questions-list-item-content">
                    {{ item.content }}
                  </div>

                  <div style="display: table; width: 80%; margin-left: 9.5%">
                    <div class="questions-list-item-time">
                      {{ item.showTime }} · {{ item.address }}
                    </div>
                    <div
                      v-if="live.liveStatus === 1"
                      class="questions-list-item-reply"
                      @click="reply(item)"
                    >
                      回复
                    </div>
                  </div>

                  <div
                    class="show-reply"
                    v-if="item.lowerCount > 0 && item.show"
                    @click="showLower(item)"
                  >
                    ---------展开 {{ item.lowerCount }}条回复 ⅴ
                  </div>
                  <div
                    class="lower-list-item"
                    v-for="(lowerItem, lowerIndex) in item.lowerList"
                    :key="lowerIndex"
                  >
                    <block v-if="!item.show">
                      <div class="lower-list-item-heading">
                        <img
                          :src="
                            lowerItem.avatar
                              ? lowerItem.avatar
                              : require('../../../assets/img/timg.jpg')
                          "
                        />
                        <span class="lower-list-item-username">
                          {{ lowerItem.nick }}</span
                        >
                        <span
                          v-if="lowerItem.userId == userId"
                          style="
                            margin-left: 5px;
                            background-color: #f0f0f0;
                            width: 30px;
                            display: inline-block;
                            text-align: center;
                          "
                        >
                          <font color="#BEBEBE">我</font>
                        </span>
                        <img
                          v-if="lowerItem.parentName != null"
                          style="width: 10px; height: 10px; margin-left: 5px"
                          src="../../../assets/img/sanjiao.png"
                        />
                        <span
                          v-if="lowerItem.parentName != null"
                          class="lower-list-item-username"
                          >{{ lowerItem.parentName }}</span
                        >
                      </div>
                      <div class="lower-list-item-content">
                        {{ lowerItem.content }}
                      </div>

                      <div
                        style="display: table; width: 80%; margin-left: 9.5%"
                      >
                        <div class="lower-list-item-time">
                          {{ lowerItem.showTime }} · {{ lowerItem.address }}
                        </div>
                        <div
                          v-if="live.liveStatus === 1"
                          class="lower-list-item-reply"
                          @click="reply(lowerItem)"
                        >
                          回复
                        </div>
                      </div>
                    </block>
                  </div>
                </div>
                <div
                  v-if="!commentNone"
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                  @click="loadMoreComment"
                >
                  点击加载更多...
                </div>
                <div
                  v-else
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                >
                  暂无更多数据...
                </div>
              </div>
            </mt-tab-container-item>
            <!-- 提问区域 -->
            <mt-tab-container-item id="score">
              <div class="score">
                <!-- 提问列表展示区域 -->
                <div class="questions-list" :style="{ marginTop: topHeight }">
                  <div
                    class="questions-list-item"
                    v-for="(item, index) in questList"
                    :key="index"
                  >
                    <div class="questions-list-item-heading">
                      <img
                        :src="
                          item.avatar
                            ? item.avatar
                            : require('../../../assets/img/timg.jpg')
                        "
                      />
                      <span class="questions-list-item-username">{{
                        item.nick
                      }}</span>

                      <span
                        v-if="item.userId == userId"
                        style="
                          background-color: #f0f0f0;
                          width: 30px;
                          display: inline-block;
                          text-align: center;
                        "
                      >
                        <font color="#BEBEBE">我</font>
                      </span>
                    </div>

                    <div class="questions-list-item-content">
                      {{ item.queContent }}
                    </div>

                    <div style="display: table; width: 80%; margin-left: 9.5%">
                      <div class="questions-list-item-time">
                        {{ item.showTime }} · {{ item.address }}
                      </div>
                      <div
                        v-if="live.liveStatus === 1"
                        class="questions-list-item-reply"
                        @click="questionReply(item)"
                      >
                        回复
                      </div>
                    </div>
                    <div
                      class="show-reply"
                      v-if="item.lowerCount > 0 && item.show"
                      @click="showLower(item)"
                    >
                      ---------展开 {{ item.lowerCount }}条回复 ⅴ
                    </div>

                    <div
                      v-if="!item.show"
                      class="lower-list-item"
                      v-for="(lowerItem, lowerIndex) in item.lowerList"
                      :key="lowerIndex"
                    >
                      <div class="lower-list-item-heading">
                        <img
                          :src="
                            lowerItem.avatar
                              ? lowerItem.avatar
                              : require('../../../assets/img/timg.jpg')
                          "
                        />
                        <span class="lower-list-item-username">
                          {{ lowerItem.nick }}</span
                        >
                        <span
                          v-if="lowerItem.userId == userId"
                          style="
                            margin-left: 5px;
                            background-color: #f0f0f0;
                            width: 30px;
                            display: inline-block;
                            text-align: center;
                          "
                        >
                          <font color="#BEBEBE">我</font>
                        </span>
                        <img
                          v-if="lowerItem.parentName != null"
                          style="width: 10px; height: 10px; margin-left: 5px"
                          src="../../../assets/img/sanjiao.png"
                        />
                        <span
                          v-if="lowerItem.parentName != null"
                          class="lower-list-item-username"
                          >{{ lowerItem.parentName }}</span
                        >
                      </div>
                      <div class="lower-list-item-content">
                        {{ lowerItem.queContent }}
                      </div>

                      <div
                        style="display: table; width: 80%; margin-left: 9.5%"
                      >
                        <div class="lower-list-item-time">
                          {{ lowerItem.showTime }} · {{ lowerItem.address }}
                        </div>
                        <div
                          v-if="live.liveStatus === 1"
                          class="lower-list-item-reply"
                          @click="questionReply(lowerItem)"
                        >
                          回复
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="!questionNone"
                    style="
                      text-align: center;
                      font-size: 12px;
                      color: #666;
                      margin-top: 10px;
                    "
                    @click="loadMoreQuestion"
                  >
                    点击加载更多...
                  </div>
                  <div
                    v-else
                    style="
                      text-align: center;
                      font-size: 12px;
                      color: #666;
                      margin-top: 10px;
                    "
                  >
                    暂无更多数据...
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <!-- 联系我们 -->
            <mt-tab-container-item id="note">
              <div :style="{ marginTop: topHeight }">
                <div class="timg" v-if="live.liveCrowdGroup">
                  <img :src="live.liveCrowdGroup" />
                </div>
                <div v-else>
                  <div class="columns">
                    <img src="../../../assets/img/list1.png" />
                    <span class="p-title">直播介绍</span>
                    <p
                      class="p-desc"
                      v-html="live.liveDetail"
                      v-clipboard:copy="live.liveDetail"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      @click="imageChgange($event)"
                    ></p>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
          </mt-tab-container>
        </div>
      </div>
    </div>
    <div class="container input_footer">
      <div class="row input_footer">
        <div
          v-if="live.liveStatus === 1 && selected === 'comment'"
          class="col-md-8 offset-md-2 input_footer"
        >
          <div class="noteBottom" style="width: 80%">
            <input
              v-model="comment"
              required="true"
              :placeholder="commentPlaceHolder"
              id="textpanel"
              style="width: 80%"
              maxlength="100"
              autofocus="autofocus"
              ref="comment"
              @blur="unFocus"
            />
            <span style="clolr: #bbb; font-size: 12px"
              >{{ comment.length }}/100</span
            >
          </div>
          <button
            @click="addComments(comment)"
            class="comment-send-btn"
            :class="btndisabled ? 'disableClass' : ''"
            :disabled="btndisabled"
          >
            {{ showTime ? btnTime + ' s' : '发送' }}
          </button>
        </div>
        <div
          v-if="live.liveStatus === 1 && selected === 'score'"
          class="col-md-8 offset-md-2 input_footer"
        >
          <div v-if="sendType == 1" class="noteBottom" style="width: 80%">
            <input
              v-model="askText"
              required="true"
              :placeholder="questionPlaceHolder"
              id="textpanel"
              style="width: 80%"
              maxlength="100"
              autofocus="autofocus"
              ref="questionRep"
              @blur="questionUnFocus"
            />
            <span style="clolr: #bbb; font-size: 12px"
              >{{ comment.length }}/100</span
            >
          </div>
          <button
            v-if="sendType == 1"
            @click="addQuestion(askText)"
            class="comment-send-btn"
            :class="btndisabled ? 'disableClass' : ''"
            :disabled="btndisabled"
          >
            {{ showTime ? btnTime + ' s' : '回复' }}
          </button>

          <div v-if="sendType == 0" class="noteBottom" style="width: 80%">
            <a @click="getCerSpeciality">{{ teacher || '@讲师' }}</a>
            <!-- 提问讲师列表 -->
            <mt-popup
              v-model="cerSpecialityShow"
              position="bottom"
              popup-transition="popup-fade"
              fixed
            >
              <div
                style="height: 60px"
                @click="askTeacher(teacher)"
                class="showPopup"
              >
                完成
              </div>
              <mt-picker
                :slots="dataSlots"
                :visibleItemCount="5"
                valueKey="name"
                @change="onCerSpecialityChange"
              ></mt-picker>
            </mt-popup>
            <input
              required="true"
              v-model="askText"
              style="width: 60%"
              placeholder="请写下您的问题"
              maxlength="100"
            />
            <span style="clolr: #bbb; font-size: 12px"
              >{{ askText.length }}/100</span
            >
          </div>
          <button
            v-if="sendType == 0"
            @click="addQuestion(askText)"
            class="comment-send-btn"
            :class="btndisabled ? 'disableClass' : ''"
            :disabled="btndisabled"
          >
            {{ showTime ? btnTime + ' s' : '提问' }}
          </button>
        </div>
      </div>
    </div>
    <!-- 客户信息弹出框 -->
    <van-dialog
      v-model="initeVisible"
      title="信息输入"
      :lazy-render="false"
      close-on-popstate
      :show-confirm-button="false"
    >
      <van-form @submit="confirm">
        <van-field
          v-model="user.name"
          label="姓名"
          placeholder="请输入姓名"
          required
          :rules="[{ required: true }]"
          clearable
        />
        <van-field
          v-model="user.address"
          label="省市区"
          placeholder="请选择省市区"
          readonly
          :rules="[{ required: true }]"
          required
          clearable
          @click="cascadershow = true"
        />
        <van-field
          v-model="user.hospital"
          label="医院"
          placeholder="请输入医院"
          :rules="[{ required: true }]"
          required
          clearable
        />
        <van-field
          v-model="user.inviteCode"
          label="邀请码"
          placeholder="选填"
          clearable
        />
        <div style="text-align: right; padding: 10px">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </van-dialog>
    <van-popup v-model="cascadershow" round position="bottom">
      <van-area
        @cancel="cascadershow = false"
        :area-list="areaList"
        @confirm="selectAddress"
      />
    </van-popup>
  </div>
</template>

<script>
let timer = null
let timeInterval = null
import Base64 from 'base-64'
import ReconnectingWebSocket from 'reconnecting-websocket'
import Search from '../../../components/Search'
import { ImagePreview } from 'vant'
import CourseMeans from '../../../components/details/CourseMeans'
import { areaList } from '../../../assets/json/area'
import { videoShare } from '@/common/wxshare'
import Player from 'xgplayer'
import HlsJsPlayer from 'xgplayer-hls.js'
import FlvJsPlayer from 'xgplayer-flv'
import { Dialog } from 'vant'
export default {
  // 离开当前页，断开websock
  beforeRouteLeave(to, form, next) {
    var node = document.getElementsByTagName('body')[0]
    if (node.classList.contains('van-overflow-hidden')) {
      this.$router.go(1)
      return
    }
    if (timer) {
      clearInterval(timer)
    }
    if (this.websock) {
      this.websock.close()
    }
    this.websock = null
    next()
  },
  components: { CourseMeans, Search },
  data() {
    return {
      btnTime: 10,
      showTime: false,
      btndisabled: false,
      cerSpecialityShow: false,
      initeVisible: false,
      cascadershow: false,
      username: '',
      cascaderValue: '',
      areaList: areaList,
      // 讲师选择
      dataSlots: [
        {
          flex: 1,
          values: [],
        },
      ],
      // 邀请信息
      user: {
        name: '',
        hospital: '',
        address: '',
        inviteCode: '',
      },
      // 人数
      total: 0,
      tims: 0,
      tim: 0,
      current: {
        total: 0,
        times: 0,
      },
      teacherSub: '',
      liveId: this.$route.query.liveId,
      questList: [],
      commentLists: [],
      comment: '',
      selected: 'score',
      commentText: '',
      askText: '',
      teacher: '',
      showNotice: true,
      teachers: [],
      live: {},
      websock: null,
      isAuth: false,
      userInfo: {},
      state: null,
      isliving: true,
      isKeyword: false,
      routeLive: '',
      commentIndex: 0,
      questionIndex: 0,
      commentNone: false,
      questionNone: false,
      // 动态获取视频高度
      topHeight: null,
      // 回放视频是否生成：true=>是，false=>否
      historyUrl: true,
      // 直播是否关闭：true=>是，false=>否
      liveEnter: false,
      player: null,
      liveUrl: '',
      activited: 1,
      commentPlaceHolder: '善语结善缘，恶语伤人心~',
      questionPlaceHolder: '善语结善缘，恶语伤人心~',
      parent: null,
      sendType: 0,
      questionParent: null,
      comments: [],
    }
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number],
      }
    },
  },
  mounted() {
    this.routeLive = sessionStorage.getItem('routeLive')
    this.handleComments()
  },
  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    if (this.userInfo) {
      this.user.name = this.userInfo?.name || ''
      this.user.address = this.userInfo?.address?.split('-') || []
      this.user.hospital = this.userInfo?.hospital || ''
    }
    const _this = this
    _this.getLiveInfo(true)
    //2.销毁获取评论
    _this.getAllComments()
    //3. 销毁获取提问
    _this.getAllQuestions()
  },
  methods: {
    confirm() {
      let _this = this
      let address = this.user.address.split(',')
      _this
        .$http({
          url: `/live/invite-user/save`,
          method: 'post',
          data: {
            userId: this.userId,
            liveId: this.liveId,
            ...this.user,
            address: address.join('-'),
          },
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            _this.$toast('提交成功')
            _this.initeVisible = false
          } else {
            Dialog.alert({
              message: data.msg ? data.msg : '提交失败',
            }).then(() => {
              // on close
            })
            _this.$toast(data.msg ? data.msg : '提交失败')
          }
        })
    },
    selectAddress(val) {
      console.log(val)
      this.user.address = [val[0].name, val[1].name, val[2].name]
      this.cascadershow = false
    },
    onCopy(e) {
      this.$toast('复制成功！')
    },
    onError(e) {
      this.$toast('复制失败！')
    },
    // 计算弹幕数组
    handleComments() {
      let userInfo = sessionStorage.getItem('userInfo')
      this.comments = []
      // 计算一天的毫秒数
      let ms = 24 * 60 * 1000
      // 计算弹幕数
      let num = ms / 10000
      // 渲染弹幕数组
      let num2 = ms / 100000
      for (var i = 0; i <= num2; i++) {
        this.comments.push({
          duration: 15000,
          id: i + Math.floor(Math.random() * 50000),
          start: i * 100000,
          txt: '【版权声明】本直播课程版权归授课专家所有，为尊重和保护专家的知识产权及劳动付出，请勿进行任何形式的录屏及翻录，谢谢！',
          mode: 'scroll',
          style: {
            //弹幕自定义样式
            color: '#bfbfbf',
            fontSize: '12px',
            borderRadius: '50px',
            padding: '3px 11px',
          },
        })
      }
      for (var i = 0; i <= num; i++) {
        this.comments.push({
          duration: 10000,
          id: i,
          start: i * 60000,
          txt: userInfo ? JSON.parse(userInfo).mobile : '',
          mode: 'scroll',
          style: {
            //弹幕自定义样式
            color: '#bfbfbf',
            fontSize: '12px',
            borderRadius: '50px',
            padding: '3px 11px',
            // backgroundColor: 'rgba(255, 255, 255, 0.5)',
            marginTop: Math.floor(Math.random() * (180 - 1) + 1) + 'px',
          },
        })
      }
    },
    // 线路切换
    switchLine(num) {
      this.player.pause()
      if (this.activited == num) {
        return
      }
      this.activited = num
      setTimeout(() => {
        this.player.destroy()
        if (num == 1) {
          this.player = new HlsJsPlayer({
            id: 'vs',
            url: this.liveUrl + '.m3u8',
            autoplay: false,
            poster: this.live.liveCoverImg, //视频封面
            lang: 'zh-cn',
            fluid: true,
            ignores: ['time'],
            playsinline: true,
            webkitPlaysinline: false,
            danmu: {
              comments: this.comments,
              closeDefaultBtn: true,
              defaultOff: false,
              panel: false,
            },
          })
        } else if (num == 2) {
          this.player = new FlvJsPlayer({
            id: 'vs',
            url: this.liveUrl + '.flv',
            isLive: true,
            cors: true,
            autoplay: false,
            poster: this.live.liveCoverImg, //视频封面
            lang: 'zh-cn',
            fluid: true,
            ignores: ['time'],
            playsinline: true,
            webkitPlaysinline: false,
            danmu: {
              comments: this.comments,
              closeDefaultBtn: true,
              defaultOff: false,
              panel: false,
            },
          })
        }
      }, 10)
    },
    // 获取直播详情信息
    getLiveInfo(flag) {
      const _this = this
      let token = sessionStorage.getItem('token')
      this.$http({
        url: `/client/live/getLiveDetails/${this.liveId}`,
        method: 'post',
        headers: {
          authorization: token,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.liveInfo = data.data
          this.wxShare(this.liveInfo)
          this.isPerfect = this.liveInfo.isPerfect
          this.detShows = false
          if (data && data.code === 0) {
            _this
              .$http({
                url: `/live/topicLive/saveTopicLive`,
                method: 'post',
                params: {
                  userId: this.userId,
                  liveId: this.liveId,
                },
              })
              .then(({ data }) => {})
            //1. 获取校验状态信息
            let {
              liveStatus,
              liveSignUp,
              livePay,
              isSingUp,
              isPurchase,
              isPerfect,
            } = data.data

            //2. 校验是否可以观看直播
            if (
              (liveSignUp === 0 && isSingUp != 3) ||
              isPurchase == 1 ||
              isPerfect != 1 ||
              liveStatus == 0
            ) {
              location.href =
                process.env.VUE_APP_PAGEURL + 'details?liveId=' + this.liveId
            }
            //3. 校验直播状态信息-》通告信息
            const Data = data.data
            if (Data.liveIsInvite == 1 && !Data.isFillInvite && liveStatus == 1)
              _this.initeVisible = true
            // 4. 历史直播，校验回放直播是否生成
            if (liveStatus === 2) {
              // flag=>false 不用校验，flag=>true需要校验
              if (flag) {
                _this.checkHistoryVideo(Data.adapter.adpHistoryUrl)
              }
            }

            _this.live = Data
            if (_this.live.liveAttr) {
              _this.live.liveAttr = JSON.parse(_this.live.liveAttr)
            }

            _this.live.liveStartTime = _this.live.liveStartTime.substring(0, 19)
            _this.live.liveEndTime = _this.live.liveEndTime.substring(0, 19)
            _this.dataSlots[0].values = _this.live.liveLecturers.split(',')
            _this.teachers = _this.live.liveLecturers.split(',')
            if (liveStatus === 0) {
              _this.$toast('该直播暂未开始，不能观看')
              _this.$router.go(-1)
              return
            }
            if (liveStatus === 1 || liveStatus === 2) {
              _this.showNotice = true
              _this.isliving = false
              if (flag) {
                _this.initWebSocket()
              }
              //广播消息隐藏
              setTimeout(function () {
                _this.$nextTick(() => {
                  _this.showNotice = false
                })
              }, 180000)
            }
            this.liveUrl = Data.adapter.adpPlayUrl.substring(
              0,
              Data.adapter.adpPlayUrl.length - 5
            )
            if (liveStatus === 1) {
              this.player = new HlsJsPlayer({
                id: 'vs',
                url: this.liveUrl + '.m3u8',
                autoplay: false,
                poster: Data.liveCoverImg, //视频封面
                lang: 'zh-cn',
                fluid: true,
                ignores: ['time'],
                playsinline: true,
                webkitPlaysinline: false,
                danmu: {
                  comments: this.comments,
                  closeDefaultBtn: true,
                  defaultOff: false,
                  panel: false,
                },
              })
            } else if (liveStatus === 2) {
              this.player = new Player({
                id: 'vs',
                url: Data.adapter.adpHistoryUrl,
                // url: 'http://lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/byted-player-videos/1.0.0/xgplayer-demo.mp4',
                autoplay: false,
                poster: Data.liveCoverImg, //视频封面
                playbackRate: [0.75, 1, 1.25, 1.5, 2],
                lang: 'zh-cn',
                fluid: true,
                webkitPlaysinline: false,
                playsinline: true,
                danmu: {
                  comments: this.comments,
                  closeDefaultBtn: true,
                  defaultOff: false,
                  panel: false,
                },
              })
            }
            setTimeout(() => {
              _this.caclHeight()
            }, 100)
          }
        } else if (data.code == 500) {
          this.$toast('该直播不存在!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000)
        }
      })
    },
    // tabbar切换，页面置顶
    getCurrentSelect() {
      clearInterval(timeInterval)
      this.btnTime = 10
      this.btndisabled = false
      this.showTime = false
      this.teacher = ''
      this.askText = ''
      this.comment = ''
      window.scrollTo(0, 0)
    },
    // 动态获取视频固定高度
    caclHeight() {
      this.topHeight = this.$refs.topHeight.offsetHeight + 'px'
    },
    // 富文本照片放大显示
    imageChgange(e) {
      if (e.target.nodeName == 'IMG') {
        ImagePreview({
          images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
          showIndex: false,
          loop: false,
          closeOnPopstate: true,
        })
      } else {
        return
      }
    },
    // 讲师下拉列表值改变
    onCerSpecialityChange(picker, values) {
      if (values[0]) {
        this.teacherSub = '@' + values[0]
      }
      if (this.cerSpecialityShow) {
        if (values[0]) {
          this.teacher = '@' + values[0]
        }
      }
    },
    // 控制讲师下拉列表显示、隐藏
    getCerSpeciality() {
      this.teacher = this.teacherSub
      this.cerSpecialityShow = true
    },
    // 刷新页面
    refresh() {
      location.reload()
    },
    // 微信是否分享
    noShare() {
      let _this = this
      if (typeof WeixinJSBridge == 'undefined') {
        //微信浏览器内置对象。参考微信官方文档
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            _this.onBridgeReady(),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady())
          document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady())
        }
      } else {
        _this.onBridgeReady()
      }
    },
    onBridgeReady: function () {
      WeixinJSBridge.call('hideOptionMenu')
    },
    //获取历史评论
    getAllComments() {
      localStorage.removeItem('commentLists_' + this.liveId)
      this.$http({
        url: `/live/userLiveComments/getCommentsByPage2`,
        method: 'get',
        params: {
          index: this.commentIndex,
          liveId: this.liveId,
          userId: this.userId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.commentNone = true
            return this
          }
          if (data.data.length) {
            localStorage.setItem(
              'commentLists_' + this.liveId,
              JSON.stringify(data.data)
            )
            this.commentLists = this.commentLists.concat(data.data)
            console.log(this.commentLists)
          }
        } else {
          this.commentIndex = 0
          this.commentLists = []
        }
      })
    },
    // 评论加载更多
    loadMoreComment() {
      this.commentIndex = this.commentIndex + 10
      this.getAllComments()
    },
    //获取历史提问
    getAllQuestions() {
      localStorage.removeItem('questList_' + this.liveId)
      this.$http({
        url: `/live/livequestioninfor/getQuestionsByPage`,
        method: 'get',
        params: {
          liveId: this.liveId,
          index: this.questionIndex,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.questionNone = true
            return this
          }
          if (data.data.length) {
            localStorage.setItem(
              'questList_' + this.liveId,
              JSON.stringify(data.data)
            )
            this.questList = this.questList.concat(data.data)
          }
        } else {
          this.questionIndex = 0
          this.this.questList = []
        }
      })
    },
    // 提问加载更多
    loadMoreQuestion() {
      this.questionIndex = this.questionIndex + 10
      this.getAllQuestions()
    },
    // 初始化webscoket
    initWebSocket() {
      if (timer) {
        clearInterval(timer)
      }
      // 初始化weosocket
      let obj = {}
      obj.id = this.userInfo ? this.userInfo.userId : ''
      obj.liveId = this.liveId
      obj.status = this.live.liveStatus
      obj.token = '123456'
      console.log(obj)
      const wsuri =
        this.$wxBaseURL + '?request=' + Base64.encode(JSON.stringify(obj))
      this.websock = new ReconnectingWebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen(e) {
      // 连接建立之后执行send方法发送数据
      console.log('Connection open ...')
      this.openInvake(e)
    },
    websocketonerror() {
      // 连接建立失败重连
      // this.initWebSocket()
    },
    websocketonmessage(e) {
      // 数据接收
      let _this = this
      const redata = JSON.parse(e.data)
      console.log('数据接收' + redata)
      var data = eval('(' + e.data + ')')
      console.log('onmessage data: ' + JSON.stringify(data))
      switch (data.uri) {
        case (1 << 8) | 220: // ping message
        case (2 << 8) | 220: // pong message
          console.log('ping message: ' + JSON.stringify(data))
          _this.pingInvake(data)
          break
        case (3 << 8) | 220: // system message
          _this.sysInvake(data)
          break
        case (4 << 8) | 220: // error message
          console.log('error message: ' + JSON.stringify(data))
          _this.closeInvake(null)
          break
        case (5 << 8) | 220: // auth message
          console.log('auth message: ' + JSON.stringify(data))
          break
        case (6 << 8) | 220: // broadcast message   //评论消息
          _this.broadcastInvake(data)
          // window.scrollTo(0, 0)
          break
        case (7 << 8) | 220: // 提问消息
          _this.broadcastInvake(data)
          // window.scrollTo(0, 0)
          break
        case 30001: // 修改直播
          console.log('修改直播')
          _this.getLiveInfo(false)
          break
        case 30002: // 开启直播
          console.log('开启直播')
          break
        case 30003: // 关闭直播
          console.log('关闭直播')
          if (_this.websock) {
            _this.websock.close()
            _this.websock = null
          }
          _this.live.liveStatus = 2
          _this.liveEnter = true
          break
        case 30004: // 提问删除
          console.log('提问删除')
          var ids = JSON.parse(e.data).extend.ids?.split('_')
          var arr = []
          this.questList.length > 0 &&
            this.questList.forEach((e) => {
              if (ids.indexOf(e.liveQuestionId + '') == -1) {
                arr.push(e)
              }
            })
          this.questList = arr
          break
        case 30005: //评论删除
          console.log('评论删除')
          var ids = JSON.parse(e.data).extend.ids?.split('_')
          var arr = []
          this.commentLists.length > 0 &&
            this.commentLists.forEach((e) => {
              if (ids.indexOf(e.commentsId + '') == -1) {
                arr.push(e)
              }
            })
          this.commentLists = arr
          break
        case 10087:
          let body = JSON.parse(data.body)

          this.commentLists.forEach((e) => {
            if (body.commentsId == e.commentsId) {
              e.praiseCount = body.praiseCount
            }
            e.lowerList.forEach((el) => {
              if (body.commentsId == el.commentsId) {
                el.praiseCount = body.praiseCount
              }
            })
          })
          break
      }
    },
    websocketclose(e) {
      // 关闭
      console.log('断开连接', e)
      this.closeInvake(e)
    },
    send(auth, mess) {
      //发送消息的时候触发
      if (!window.WebSocket || !this.websock) {
        return
      }
      if (this.websock.readyState == WebSocket.OPEN || auth) {
        console.log('send: ' + mess)
        this.websock.send(mess)
      } else {
        console.log('连接没有成功，请重新登录')
      }
    },
    openInvake(e) {
      timer = setInterval(() => {
        this.pingInvake()
      }, 40000)
    },
    closeInvake(e) {
      console.log('登录失败，网络连接异常')
    },
    sysInvake(data) {
      switch (data.extend.code) {
        case 20001: // user count
          console.log('current user: ' + data.extend.mess)
          if (this.live.liveStatus === 2) {
            this.total = data.extend.mess
          } else {
            const current = data.extend.mess.split('_')
            this.current.total = current[0]
            this.current.times = current[1]
          }
          break
        case 20002: // auth
          console.log('auth result: ' + data.extend.mess)
          this.isAuth = data.extend.mess
          if (this.isAuth) {
            console.log('欢迎来到HF聊天室！')
          }
          break
        case 20003: // system message
          console.log('system message: ' + data.extend.mess)
          break
        case 20004: // system message
          break
      }
    },
    broadcastInvake(data) {
      console.log('我是广播消息:')

      let obj = JSON.parse(data.body)
      if (data.uri === 1756) {
        obj.content = obj.msg
        obj.avatar = obj.icon

        //         alert(JSON.stringify(obj));
        //         obj.commentsId = obj.msgId
        if (obj.rootId == null) {
          this.commentLists.unshift(obj)
          localStorage.setItem(
            'commentLists_' + this.liveId,
            JSON.stringify(this.commentLists)
          )
        } else {
          this.commentLists.forEach((e) => {
            if (e.commentsId == obj.rootId) {
              if (e.lowerList == null) {
                e.lowerList = []
              }
              e.lowerList.push(obj)
              if (e.lowerCount == null) {
                e.lowerCount = 1
              } else {
                e.lowerCount += 1
              }
              if (e.show == null) {
                e.show = true
              }
            }
          })
        }
      } else if (data.uri === 2012) {
        obj.avatar = obj.icon
        obj.queContent = obj.content
        //         obj.liveQuestionId = obj.msgId
        //         this.questList.unshift(obj)
        if (obj.rootId == null) {
          this.questList.unshift(obj)
          localStorage.setItem(
            'questList_' + this.liveId,
            JSON.stringify(this.questList)
          )
        } else {
          this.questList.forEach((e) => {
            if (e.liveQuestionId == obj.rootId) {
              if (e.lowerList == null) {
                e.lowerList = []
              }
              e.lowerList.push(obj)
              if (e.lowerCount == null) {
                e.lowerCount = 1
              } else {
                e.lowerCount += 1
              }
              if (e.show == null) {
                e.show = true
              }
            }
          })
        }
      }
    },
    pingInvake(data) {
      //发送pong消息响应
      this.send(this.isAuth, "{'code':10016}")
    },
    //发表评论
    addComments(commentVal) {
      var _parent = null
      if (this.parent != null) {
        _parent = JSON.parse(JSON.stringify(this.parent))
      }
      // 判断评论是否为空
      //       this.btndisabled = true
      let comment = commentVal.trim()
      if (comment.length > 100) {
        this.btndisabled = false
        this.$toast({
          message: '评论内容不能超过100个字',
          position: 'bottom',
          duration: 1500,
        })

        return
      }
      if (comment === '') {
        this.btndisabled = false
        this.$toast({
          message: '评论内容不能为空',
          position: 'bottom',
          duration: 1500,
        })

        return
      }
      // 判断评论是否包含关键词
      this.$http({
        url: '/live/commentsKeywords/listKeys',
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const kws = data.data.split(',')
          const i = comment.search(new RegExp(kws.join('|')))
          if (i != -1) {
            this.$toast({
              message: '包含敏感词，禁止发送',
              position: 'bottom',
              duration: 1500,
            })
            this.btndisabled = false
            return this
          }
          this.state = 0
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state
          obj.liveStatus = this.live.liveStatus
          obj.msg = comment

          if (_parent != null) {
            obj.parentId = _parent.commentsId
            if (_parent.rootId == null) {
              obj.rootId = _parent.commentsId
            } else {
              obj.rootId = _parent.rootId
            }
            obj.parentName = _parent.nick
          }
          obj.address = this.userInfo.address
          if (obj.msg) {
            //             this.timeBtnClick()
            this.send(true, JSON.stringify(obj))
          }

          this.comment = ''
          // this.btndisabled = false
        } else {
          this.state = 0
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state
          obj.liveStatus = this.live.liveStatus
          obj.msg = comment
          if (obj.msg) {
            //             this.timeBtnClick()
            this.send(true, JSON.stringify(obj))
          }
          this.comment = ''
          // this.btndisabled = false
        }
      })
    },
    // 唤起评论提问按钮倒计时
    timeBtnClick() {
      this.showTime = true
      timeInterval = setInterval(() => {
        this.btnTime--
        if (this.btnTime <= 0) {
          this.showTime = false
          this.btnTime = 10
          this.btndisabled = false
          clearInterval(timeInterval)
        }
      }, 1000)
    },
    // 发布提问
    addQuestion(askTextVal) {
      var _parent = null
      var _sendType = this.sendType
      if (this.questionParent != null) {
        _parent = JSON.parse(JSON.stringify(this.questionParent))
      }

      //       this.btndisabled = true
      let askText = askTextVal.trim()
      // 判断提问是否为空
      if (askText === '') {
        this.btndisabled = false
        this.$toast({
          message: '请输入提问内容',
          position: 'bottom',
          duration: 1500,
        })

        return this
      }
      if (askText.length > 100) {
        this.btndisabled = false
        this.$toast({
          message: '提问内容不能超过100个字',
          position: 'bottom',
          duration: 1500,
        })

        return
      }
      if (_sendType == 0 && !this.teacher) {
        this.btndisabled = false
        this.$toast({
          message: '请选择要提问的老师',
          position: 'bottom',
          duration: 1500,
        })

        return this
      }
      // 判断提问是否包含关键字
      this.$http({
        url: '/live/commentsKeywords/listKeys',
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const kws = data.data.split(',')
          const i = askText.search(new RegExp(kws.join('|')))
          if (i != -1) {
            this.btndisabled = false
            this.$toast({
              message: '包含敏感词，禁止发送',
              position: 'bottom',
              duration: 1500,
            })
            return this
          }
          this.state = 1
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state

          obj.lecturer = this.teacher
          obj.liveStatus = this.live.liveStatus

          if (_parent != null) {
            obj.parentId = _parent.liveQuestionId
            if (_parent.rootId == null) {
              obj.rootId = _parent.liveQuestionId
            } else {
              obj.rootId = _parent.rootId
            }
            obj.parentName = _parent.nick
          }
          obj.address = this.userInfo.address

          if (_sendType == 0) {
            obj.content = this.teacher + ' ' + askText
            if (obj.content.indexOf('@') != -1) {
              if (obj.lecturer.indexOf('@') != -1) {
                //                     this.timeBtnClick()
                this.send(true, JSON.stringify(obj))
              }
            }
          } else {
            obj.content = askText
            //         	  this.timeBtnClick()
            this.send(true, JSON.stringify(obj))
          }

          this.askText = ''
          this.teacher = ''
          // this.btndisabled = false
        } else {
          this.state = 1
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state
          obj.content = this.teacher + ' ' + askText
          obj.lecturer = this.teacher
          obj.liveStatus = this.live.liveStatus
          if (obj.content.indexOf('@') != -1) {
            if (obj.lecturer.indexOf('@') != -1) {
              //               this.timeBtnClick()
              this.send(true, JSON.stringify(obj))
            }
          }
          this.askText = ''
          this.teacher = ''
          // this.btndisabled = false
        }
      })
    },

    // 校验历史回放
    checkHistoryVideo(url) {
      let _this = this
      _this.$http.head(url, {
        validateStatus: function (code) {
          if (code >= 300) {
            // 历史直播未生成
            _this.historyUrl = false
          }
        },
      })
    },
    // @老师
    askTeacher() {
      this.cerSpecialityShow = false
    },
    getComment(score) {
      this.commentText += score
    },
    wxShare(liveInfo) {
      //分享
      let shareTitle = 'LUMI智播'
      let shareUrl = location.href
      let shareImg =
        liveInfo.livePosterImg ||
        'https://m-live-bucket.oss-cn-beijing.aliyuncs.com/2020/08/06/cc5bca97-89a8-46eb-8fd7-8f6c7c0f7ed0_f97d247b94aa981b37e164ff2f57b34.png'
      let shareDesc = '关注LUMI智播公众号，查看更多精彩直播'
      videoShare(this, shareTitle, shareUrl, shareImg, shareDesc)
    },
    reply(parent) {
      this.commentPlaceHolder = '回复 @' + parent.nick + '：'
      this.parent = parent
      this.$nextTick(() => {
        this.$refs.comment.focus()
      })
    },
    unFocus() {
      this.commentPlaceHolder = '善语结善缘，恶语伤人心~'
      setTimeout(() => {
        this.parent = null
      }, 2000)
    },
    showLower(item) {
      item.show = false
      //        var list=[];
      //        for (let obj of item.lowerList) {
      //     	    list.push(obj);
      //     	}
      //        item.lowerList=list;
      //       this.loadLowerList(item)
    },
    loadLowerList(parent) {
      this.$http({
        url: `/live/userLiveComments/getLowerById`,
        method: 'get',
        params: {
          id: parent.commentsId,
          liveId: parent.liveId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          parent.lowerList = data.data
        } else {
        }
      })
    },
    praise(item, type, yesOrNo) {
      //type:0点赞1踩
      if (this.live.liveStatus != 1) {
        return
      }
      this.state = 0
      let obj = {}
      obj.code = 10087
      obj.liveId = this.liveId
      obj.userId = this.userInfo ? this.userInfo.userId : ''
      obj.state = 2
      obj.commentsId = item.commentsId
      obj.type = type
      obj.yesOrNo = yesOrNo
      this.send(true, JSON.stringify(obj))

      if (yesOrNo) {
        item.type = type
      } else {
        item.type = null
      }
    },
    questionReply(parent) {
      //   	  alert(JSON.stringify(parent));
      this.sendType = 1
      this.questionPlaceHolder = '回复 @' + parent.nick + '：'
      this.questionParent = parent
      this.$nextTick(() => {
        this.$refs.questionRep.focus()
      })
    },
    questionUnFocus() {
      this.questionPlaceHolder = '善语结善缘，恶语伤人心~'
      setTimeout(() => {
        this.questionParent = null
        this.sendType = 0
      }, 0)
    },
  },
}
</script>

<style lang='scss' scoped>
/deep/ .xgplayer-skin-default .xgplayer-poster {
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

/deep/ .xgplayer-skin-default {
  background: #000 !important;
}

.start {
  position: absolute;
  font-size: 14px;
  top: 50%;
  left: 50%;
  color: #ffffff;
  display: block;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  padding: 5px 5px;
  transform: translate(-50%);
}

.showPopup {
  text-align: right;
  margin-right: 1rem;
  padding: 1rem 0;
  font-size: 18px;
}

/deep/ .mint-popup-bottom {
  width: 100%;
}

.info {
  img {
    width: 40px;
    display: inline-block;
    //     margin-right: 10px;
  }

  padding: 1rem;
  padding-bottom: 0;
  background-color: #fff;

  .col-red {
    color: #666;
    font-size: 12px;
  }

  p {
    // margin: 10px 0;
    // margin-bottom: 0;
    font-size: $font-title2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  span {
    margin-right: 6px;
    // margin-left: 5px;+
    font-size: 18px;
    font-style: oblique;
  }
}

.current-size {
  text-align: right;

  span {
    font-size: 12px;

    font-style: normal;
  }

  .yell {
    color: $theme-color;
  }
}

/deep/ .mint-tab-item {
  padding: 10px 0;
}

.current1 {
  color: #fff;
  padding: 5px 0;

  .title {
    color: #555;
    font-size: 12px !important;
  }

  .liveLine {
    background-color: #f2f2f2;
    color: #999;
    border-radius: 10px;
    padding: 1px 5px;
    font-size: 12px;
    font-style: normal;
  }

  .live_activited {
    background-color: $theme-color;
    color: #fff;
    border-radius: 10px;
    padding: 1px 5px;
    font-size: 12px;
    font-style: normal;
  }
}

.current {
  text-align: right;
  color: #fff;

  .spanNum {
    background-color: $theme-color;
    border-radius: 10px;
    padding: 0 5px 2px 5px;
    color: #fff;
    font-style: normal;

    span {
      font-size: 12px;
    }
  }
}
.position {
  position: relative;
}
.top_fixed {
  background-color: #fff;
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 999;
}

.questions-list {
  // margin-top: 380px;
  margin-bottom: 7rem;
  padding: 0 10px;
  overflow: scroll;

  .questions-list-item {
    margin-bottom: 20px;

    .questions-list-item-heading {
      display: inline-block;

      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .questions-list-item-username {
        margin-left: 5px;
        font-weight: bold;
        color: #d0d0d0;
      }
    }

    .comments-list-item-content {
      margin: 10px 0px;
      border-bottom: 1px solid #cccccc;

      &:last-child {
        border-bottom: 0;
      }

      span {
        vertical-align: top;
      }
    }

    .questions-list-item-content {
      padding: 0px 0 0 37px;
      word-break: break-all;
      font-weight: normal;
      font-size: 18px;
    }

    .questions-list-item-time {
      margin-left: 35px;
      font-weight: bold;
      color: #d0d0d0;
      width: 13%;
      display: table-cell;
    }

    .questions-list-item-reply {
      margin-left: 35px;
      font-weight: bold;
      color: #8e8e8e;
      width: 5%;
      display: table-cell;
    }

    .like {
      width: 5%;
      display: table-cell;
      margin-left: 200px;
    }

    .hate {
      width: 3%;
      display: table-cell;
      margin-left: 20%;
    }

    .show-reply {
      margin-left: 35px;
      font-weight: bold;
      color: #8e8e8e;
    }
  }

  .lower-list-item {
    margin-top: 10px;
    margin-left: 10%;

    .lower-list-item-heading {
      display: inline-block;

      img {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .lower-list-item-username {
        margin-left: 5px;
        font-weight: bold;
        color: #d0d0d0;
      }
    }

    .lower-list-item-content {
      margin: 0px 0px;
      /*       border-bottom: 1px solid #cccccc; */

      &:last-child {
        border-bottom: 0;
      }

      span {
        vertical-align: top;
      }
    }

    .lower-list-item-content {
      padding: 0px 0 0 30px;
      word-break: break-all;
    }

    .lower-list-item-time {
      margin-left: 35px;
      font-weight: bold;
      color: #d0d0d0;
      width: 15%;
      display: table-cell;
    }

    .lower-list-item-reply {
      margin-left: 35px;
      font-weight: bold;
      color: #8e8e8e;
      width: 5%;
      display: table-cell;
    }

    .like {
      width: 5%;
      display: table-cell;
      margin-left: 200px;
    }

    .hate {
      width: 3%;
      display: table-cell;
      margin-left: 20%;
    }

    .show-reply {
      margin-left: 35px;
      font-weight: bold;
      color: #8e8e8e;
    }
  }
}

ul {
  background-color: #eee;
  padding: 1rem;

  li {
    text-align-last: center;
    margin: 1rem;
    color: #666;
  }
}

.timg {
  text-align: center;
  padding-top: 10%;
  padding-bottom: 40px;

  img {
    width: 60%;
    display: inline-block;
  }
}

.videoContext {
  width: 100%;
  position: relative;
  // height: 21rem;
  height: 100%;

  // padding: 30px 0;
  .hide-notice {
    display: none;
  }
}

.notice-card-wrapper {
  position: absolute;
  top: 0;
  z-index: 980;
  width: 95%;
}

/deep/ .mint-cell-wrapper,
/deep/ .mint-field-core {
  background-color: #eee;
}

.input_footer {
  background-color: #eee;
  padding: 5px;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.noteBottom {
  background-color: #fff;
  // width: 75%;
  padding-left: 5px;

  input {
    outline: none;
    border: 0;
    margin: 5px 0;
    padding-left: 5px;
    height: 30px;
  }

  a {
    font-size: 14px;
    padding-right: 10px;
    // background-color: #eee;
  }
}

.score {
  p {
    margin-left: 1rem;
  }

  .star {
    text-align: center;

    img {
      margin: 2rem 1rem 1rem 0;
      align-self: center;
    }

    button {
      margin: 2rem 2rem 0 0;
      padding: 1rem;
      border-radius: 2rem;
      height: 4rem;
      background-color: $theme-color;
      border: none;
      color: #333;
    }
  }

  /deep/ .mint-cell-wrapper {
    width: 100%;
  }
}

.barrages-drop {
  .blue {
    border-radius: 100px;
    background: #e6ff75;
    color: #fff;
  }

  .green {
    border-radius: 100px;
    background: #75ffcd;
    color: #fff;
  }

  .red {
    border-radius: 100px;
    background: #e68fba;
    color: #fff;
  }

  .yellow {
    border-radius: 100px;
    background: #dfc795;
    color: #fff;
  }

  .baberrage-stage {
    position: absolute;
    width: 100%;
    height: 212px;
    overflow: hidden;
    top: 0;
    margin-top: 130px;
  }
}

.footer-comment {
  width: 95%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  padding-left: 2rem;
  box-sizing: border-box;
  padding-bottom: 1rem;
  background-color: #fff;

  .foot-box {
    display: flex;
    align-items: center;
    /*position: relative;*/
    justify-content: space-between;
    padding: 0 1rem 0 0;
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;

    /deep/ .mint-cell {
      width: 70%;
      border-radius: 6px;
    }
  }
}

.comment-send-btn {
  width: 70px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: none;
  border-radius: 1rem;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 13px;
  color: #ffffff;
  background-color: $theme-color;

  &:hover {
    cursor: pointer;
  }
}

.columns {
  margin: 1rem;
  font-size: 18px;

  // font-weight: bold;
  img {
    display: inline-block;
    width: 20px;
    margin-bottom: 5px;
    margin-right: 10px;
    border-radius: 5px;
  }
}

.p-title {
  margin: 1rem 0;
  // font-weight: bold;
}

.p-desc {
  color: #333;
  font-size: 14px;
  line-height: 30px;
  text-indent: 2em;
  margin-top: 1rem;
}

::v-deep img {
  width: 100%;
  display: block;
}

.video-btn {
  color: #009688;
  float: right;
}

.disableClass {
  opacity: 0.6;
}

/deep/ .vjs-poster {
  background-size: cover;
}
</style>
